<template>
    <div class="cd-timeline-content cd-timeline-card--default">
        <div class="cd-timeline-content-text">
            <div v-html="oneLog.text" />
            <span class="nowrap gray-60 fs-2">
                {{ $filters.dateFormatter(oneLog.timestamp, 'NORMAL_DATE_TIME', true) }}
            </span>
        </div>

        <div v-if="oneLog.linked.length > 0" class="cd-timeline-links">
            <p>{{ $l10n.__('Associé à') }}</p>
            <ul>
                <li v-for="(link, key) in oneLog.linked" :key="key">
                    <i :class="getIconByType(oneLog.objecttype)"></i>
                    <span v-html="link.html"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import IconMixin from '../../mixins/IconMixin';
export default {
    mixins: [IconMixin],
    props: {
        oneLog: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            lang: this.$parent.lang,
        };
    },
};
</script>

<style lang="scss" scoped>
.cd-timeline-card--default {
    margin: 0 var(--spacing-0) 0 var(--spacing-3);
    padding: 0 0 var(--spacing-4);

    &::v-deep {
        strong {
            font-weight: 600;
        }

        a:hover {
            color: var(--colors-common-text-primary-default);
        }
    }
}
</style>
